import { PaginatedGroupSettings as PaginatedGroupSettingsApi } from "../API";
import { DashboardColumn, InvestmentThesis, Workspace } from "./files";

export enum DisplayType {
    Row = 'row',
    Column = 'column',
}

export interface User {
    //id: string;
    //userId?: string | undefined;
    email: string;
    firstName?: string;
    lastName?: string;
    username: string;
    group: string;
    project?: string;
    referralCode?: string;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export enum PreviewHighlightAction {
    Comment = "comment",
    Dashboard = "dashboard"
}

export enum SaveDashboardItemType {
    Page = "page",
    Text = "text",
    ScreenCapture = "capture"
}

export enum ShareType {
    Internal = 'internal',
    External = 'external'
}

export interface TagGroup {
    title: string;
    tags: string[];
    tagsPerDashboard: number;
    additionalContextQuery: string;
}

export enum CustomFieldType {
    Text = 'text',
    Metric = 'metric',
}

export enum MetricUnit {
    Currency = '$',
    Percentage = '%',
    Number = '#',
}

export interface CustomField {
    name: string;
    additionalContextQuery: string;
    type?: CustomFieldType | null;
    aliases?: (string | null)[] | null;
    unit?: MetricUnit | string | null;
}

export interface EmailFolder {
    id: string;
    name: string;
    children?: EmailFolder[];
}

export interface EmailTypeSettings {
    newDeal?: boolean;
    companyUpdate?: boolean;
    newFundOpportunity?: boolean;
    sharedPipeline?: boolean;
}

export interface GroupSettings {
    group: string;
    defaultStatus?: string;
    statuses?: string[];
    investmentStages?: string[];
    investmentThesis?: InvestmentThesis | null;
    tags?: string[];
    keyPeopleTags?: string[],
    tagGroups?: TagGroup[];
    customFields?: CustomField[];
    shouldSyncAllDashboardsExternally?: boolean;
    shouldIngestDashboardsFromEmail?: boolean;
    shouldSendDigestEmail?: boolean;
    shouldSendIngestionNotifications?: boolean,
    workspaces?: Workspace[],
    excludedCompanyTerms?: string[],
    dashboardColumns?: DashboardColumn[],
    emailFolders?: EmailFolder[],
    emailTypeSettings?: EmailTypeSettings,
    connectedApps?: string[],
}

export type PaginatedGroupSettings = Omit<PaginatedGroupSettingsApi, '__typename'>;

export enum WorkspaceUserMembershipStatus {
    ACCEPTED = "ACCEPTED",
    PENDING = "PENDING",
    REJECTED = "REJECTED",
}
